import { CLICKED_PRINT_PDF } from "./../../../common/analytics/analyticsevents";
import dictionary from "./../../../common/dictionary";
import { EEnabledFeatures } from "./../../../common/utilities/enums";
import {
  createDivWithClass,
  generateSecurePreviewURL,
  requiredParam,
} from "./../../../common/utilities/utils";
import PrintMenuComponent from "./../../../web/reader/components/printMenuComponent";
import template from "./../templates/printButtonComponent.dust";
import { getApiKeyHeader } from "./../../../common/utilities/apimanager.helper";
export default class PrintButtonComponent {
  constructor(
    DOMContainer = requiredParam("DOMContainer"),
    pubStore,
    appState,
    options,
    sessionManager
  ) {
    this._DOMContainer = DOMContainer;
    this._pubStore = pubStore;
    this._appState = appState;
    this._options = options;
    this._sessionManager = sessionManager;
  }

  render() {
    if (this._sessionManager.isFeatureEnabled(EEnabledFeatures.PRINT)) {
      const context = {
        i18n: dictionary,
        useCustomToolTip: this._options
          ? this._options.useCustomTooltips
          : false,
        displayTopNavButtonlabel: this._options
          ? this._options.displayTopNavButtonlabel
          : false,
        printCroppedPdf: this._options.print.printCroppedPdf,
      };
      Dust.render(template, context, this._renderDone.bind(this));
    }
  }

  ////////////

  _renderDone(err, result) {
    if (err) return;

    this.printButtonEl = createDivWithClass("print-button-component");
    this.printButtonEl.setAttribute("id", "print-publication");
    if (this._options && this._options.displayTopNavButtonlabel) {
      this.printButtonEl.classList.add("labelDisplayed");
    }

    this.printButtonEl.innerHTML = result;
    this.printButtonEl.classList.add("hidden");
    this._DOMContainer.appendChild(this.printButtonEl);
    this._attachEventListeners();
    if (this._options.print.printCroppedPdf) {
      this.printOptionContainer = this._DOMContainer.querySelector(
        ".print-button-component .printOption-container"
      );
    }
    this._toggleIcon();
  }

  _attachEventListeners() {
    const el = document.getElementById("print-publication");
    el.addEventListener("click", this._onClickHandler);
    this._pubStore.on("pubStore:pubLoaded", this._toggleIcon);
  }

  _onClickHandler = () => {
    this._appState.trigger("printButton:clicked");
    if (this._options.print.printCroppedPdf) {
      this.printMenuComponent = new PrintMenuComponent(
        this.printOptionContainer,
        this._pubStore,
        this._appState,
        this._options,
        this._sessionManager
      );
      this.printMenuComponent.toggleMenu();
    } else {
      this._appState.triggerEvent(CLICKED_PRINT_PDF);
      const currentPages = this._pubStore.getCurrentPages(
        this._appState.currentPage
      );
      const params = {
        headers: JSON.stringify(getApiKeyHeader()),
      };
      if (currentPages.left)
        params.leftImage = this._prepareImageUrl(currentPages.left);
      if (currentPages.right)
        params.rightImage = this._prepareImageUrl(currentPages.right);

      window.open(`print.html?${$.param(params)}`);
    }
  };

  _prepareImageUrl(page) {
    if (!page) return null;
    const { userId, sessionId, downloadId } = this._appState;
    return generateSecurePreviewURL(
      this._options.print.imageSize,
      page.PublicationPageID,
      sessionId,
      userId,
      downloadId
    );
  }

  _toggleIcon = () => {
    if (this._pubStore.isCurrentPublicationReplica()) {
      this.printButtonEl.classList.remove("hidden");
    } else {
      this.printButtonEl.classList.add("hidden");
      if (
        this.printOptionContainer &&
        !this.printOptionContainer.classList.contains("hidden")
      ) {
        this.printOptionContainer.classList.add("hidden");
      }
    }
  };

  _destroy() {
    document
      .getElementById("print-publication")
      .removeEventListener("click", this._onClickHandler);
    this._pubStore.off("pubStore:pubLoaded", this._toggleIcon);
  }
}



// WEBPACK FOOTER //
// ./src/web/reader/components/printButtonComponent.js